
export default function Services() {
  const services = [
    {
      name: 'One-Time Setup',
      description: 'Complete Instagram business profile optimization and initial campaign setup tailored for your landscaping company.',
      icon: 'ri-settings-3-line',
      category: 'Setup'
    },
    {
      name: 'Content Creation',
      description: 'Professional photography, graphic design, and copywriting for engaging Instagram posts that showcase your work.',
      icon: 'ri-image-edit-line',
      category: 'Creative'
    },
    {
      name: 'Campaign Management',
      description: 'Ongoing ad campaign optimization, posting schedule management, and performance monitoring to maximize your ROI.',
      icon: 'ri-dashboard-line',
      category: 'Management'
    }
  ];

  return (
    <section id="services" className="py-16 sm:py-32 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="mb-12 sm:mb-16">
          <h2 className="text-4xl sm:text-6xl font-serif text-gray-900 mb-1 sm:mb-2">
            <span className="font-light">Our Instagram</span>
          </h2>
          <h2 className="text-4xl sm:text-6xl font-serif font-bold text-gray-900">
            Management Services
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-10">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group bg-white rounded-2xl sm:rounded-3xl border border-gray-200 overflow-hidden hover:border-blue-300 hover:shadow-xl transition-all duration-300"
            >
              <div className="h-56 sm:h-72 bg-white flex items-center justify-center p-8 sm:p-12 relative">
                <div className="w-24 h-24 sm:w-32 sm:h-32 rounded-full bg-gradient-to-br from-emerald-500 to-blue-500 flex items-center justify-center shadow-2xl group-hover:scale-110 transition-transform duration-300">
                  <div className="w-24 h-24 sm:w-32 sm:h-32 flex items-center justify-center">
                    <i className={`${service.icon} text-4xl sm:text-6xl text-white`}></i>
                  </div>
                </div>
                <div className="absolute top-4 sm:top-6 right-4 sm:right-6 w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-gradient-to-br from-blue-100 to-emerald-100 flex items-center justify-center">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center">
                    <i className="ri-check-line text-lg sm:text-xl text-emerald-700"></i>
                  </div>
                </div>
              </div>
              
              <div className="p-6 sm:p-8 space-y-2 sm:space-y-3">
                <h3 className="text-xl sm:text-2xl font-serif text-gray-900">
                  {service.name}
                </h3>
                <p className="text-gray-600 leading-relaxed text-sm">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
